module.exports = __webpack_public_path__ + "static/media/google-logo.60cf5eb3.svg";